export const CURRENT_AGE = {
    TITLE: "Current Age (Years)",
    MIN: 20,
    MAX: 50,
    TYPE: "num",
    VALUE: 25,
};
export const RETIRE_AGE = {
    TITLE: "Retirement Age (Years)",
    MIN: 26,
    MAX: 70,
    TYPE: "num",
    VALUE: 65,
};
export const LIFE_EXP = {
    TITLE: "Life Expectancy (Years)",
    MIN: 66,
    MAX: 120,
    TYPE: "num",
    VALUE: 85,
};
export const CONTRIBUTION = {
    TITLE: "Annual Contribution ($)",
    MIN: 0,
    MAX: 40000,
    TYPE: "money",
    VALUE: 5000,
};
export const EXPENSES = {
    TITLE: "Annual Retirement Expenses ($)",
    MIN: 1,
    MAX: 1000000,
    TYPE: "money",
    VALUE: 50000,
};
